import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';

export default function Home() {
  return (
    <>
      <Header />

      <main>
        <HeroSection />
        <RankingSection />
        <CarouselSection />
        <AboutSection />
        <CardsSection />
        <AppSection />
        <IndexSection />
        <TopicsSection />
        <MediaSection />
        <UpdatesSection />
        <FaqSection />
        <ContactSection />
        <CommentsSection />
        <FeaturesSection />
      </main>

      <Footer />
    </>
  );
}